var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('static-custom-page',{attrs:{"pageSlug":this.$route.params.page_slug}}),_c('static-footer',{attrs:{"pageObj":_vm.CustomPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }